
    import '/home/runner/work/GPT-Vis/GPT-Vis/src/Spreadsheet/index.en.md?watch=parent';
    export const demoIndex = {
  ids: ["spreadsheet-demo-common","spreadsheet-demo-pivot","spreadsheet-demo-markdown"],
  getter: () => import(/* webpackChunkName: "meta__Spreadsheet__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Spreadsheet/index.en.md?type=demo')
};